export const ERRORS = {
	DEFAULT: {
		text: "That doesn’t look right",
		desc: "Something went wrong, try another photo.",
	},
	TIMEOUT: {
		text: "Connection timed out",
		desc: `Connection timed out. This sometimes happens with large photos,
			try reducing the size.`,
	},
	FILETYPE: {
		text: "Homie don’t play that",
		desc: "We only accept JPGs, PNGs, GIFs, or WEBPs.",
	},
	NOPHOTOS: {
		text: "No photos found",
		desc: "There doesn’t seem to be anything here.",
	},
	CONNECTION: {
		text: "Connection to server lost",
		desc: "We had trouble connecting. Try again in a bit.",
	},
	SOCIAL: {
		text: "Having some trouble here",
		desc: "We couldn’t connect to their service. Try again in a bit.",
	},
	TOO_LARGE: {
		text: "Whoa, that’s a biggun",
		desc: "That file is too large for us to handle. Try shrinking it.",
	},
	E_INPUT: {
		text: "Something went wrong",
		desc: "Make sure your file is a valid image, and try again.",
	},
	E_FILE_TOO_SMALL: {
		text: "Choose a bigger photo",
		desc: "Photos must be at least 400x400px.",
	},
	E_QUOTA: {
		text: "All filled up",
		desc: "This album is full.",
	},
	E_BAD_IMAGE: {
		text: "That doesn’t look right",
		desc: "There was a problem reading your photo, try another.",
	},
	E_EMPTY_FILE: {
		text: "That doesn’t look right",
		desc: "There was a problem reading your photo, try another.",
	},
	E_INVALID_URL: {
		text: "We had trouble fetching your image",
		desc: "Please try downloading the image and uploading from your computer.",
	},
};



// WEBPACK FOOTER //
// ./src/apps/photo_upload/util/constants.js